import { render, staticRenderFns } from "./MailsTab.vue?vue&type=template&id=712210fb&lang=pug&"
import script from "./MailsTab.vue?vue&type=script&lang=js&"
export * from "./MailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports